import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Box from '@nubank/nuds-web/components/Box/Box';
import Image from '@nubank/nuds-web/components/Image/Image';

import { Section } from './styles/Section';

const ConditionsSection = ({
  titleIntlKey,
  titleIntlValues,
  isHeader,
  headerBackgroundColor,
  children,
  showImage,
}) => (
  <Section isHeader={isHeader} backgroundColor={headerBackgroundColor}>
    <Box
      width="100%"
      maxWidth="1328px"
      tag="article"
    >
      <Box
        width={{
          xs: '100%',
          md: '60%',
        }}
        tag="div"
        paddingTop="16x"
        paddingHorizontal={{
          xs: '8x',
          md: '16x',
        }}
        paddingBottom={2}
        flexDirection="column"
      >

        {showImage && (
        <Image
          srcSet={{ xs: 'multi-product-home/contract/contract.png' }}
          loading="lazy"
          alt="contract"
          title="contract"
          width="150px"
          webp
        />
        )}
        <Typography
          tag={isHeader ? 'h1' : 'h2'}
          color={isHeader ? 'white' : 'black'}
          variant={isHeader ? 'heading1' : 'heading2'}
          marginBottom={32}
          intlKey={titleIntlKey}
          intlValues={titleIntlValues}
        />
        {children}
      </Box>
    </Box>
  </Section>
);

ConditionsSection.defaultProps = {
  children: undefined,
  isHeader: false,
  showImage: false,
  titleIntlValues: undefined,
  headerBackgroundColor: '#A376FF',
};

ConditionsSection.propTypes = {
  children: PropTypes.node,
  headerBackgroundColor: PropTypes.string,
  isHeader: PropTypes.bool,
  showImage: PropTypes.bool,
  titleIntlKey: PropTypes.string.isRequired,
  titleIntlValues: PropTypes.oneOfType([PropTypes.object]),
};

export default ConditionsSection;
